import { getActiveLocation } from "features/location/selectors/getLocationPermissions";
import { createSelector } from "reselect";

export const getProductVideoEnabled = createSelector(getActiveLocation, (activeLocation) => {
    return activeLocation?.enableProductVideos;
});
